import _ from 'lodash';
import { Delta } from 'quill/core';

function prepareContentForCard(delta: Delta): Delta {
  let content = new Delta();

  delta.eachLine((line, _attributes, index) => {
    if (index === 0) {
      content = content.concat(line).concat(new Delta().insert('\n'));
      return;
    }

    if (index > 1) {
      const lastOp = _.last(content.ops);
      if (typeof lastOp?.insert === 'string' && !lastOp.insert.endsWith(' ')) {
        content = content.insert(' ');
      }
    }

    line.forEach((op) => {
      if (typeof op?.insert === 'string') {
        const opDelta = new Delta([{ insert: op.insert }]);
        content = content.concat(opDelta);
      }
    });
  });

  return content;
}

export default prepareContentForCard;
